/* RoleModifyDialog — admin role modification modal. */
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

const ROLES = ['admin', 'recruiter', 'reviewer'];

export function RoleModifyDialog({ member, onClose, onSubmit }) {
  const [newRole, setNewRole] = useState(member.role === 'admin' ? 'recruiter' : 'admin');
  const [busy,    setBusy]    = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onSubmit({ targetUserId: member.user_id, newRole });
    } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="emp-role-dialog">
        <DialogHeader>
          <DialogTitle>Modify member role</DialogTitle>
          <DialogDescription>
            current role: <span className="font-mono">{member.role}</span>
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>New role</Label>
            <RadioGroup value={newRole} onValueChange={setNewRole} className="mt-2 grid grid-cols-3 gap-2"
              data-testid="emp-role-radio">
              {ROLES.map((r) => (
                <Label key={r}
                  htmlFor={`emp-role-${r}`}
                  className={`flex cursor-pointer items-center gap-2 rounded border p-2 text-sm
                    has-[[data-state=checked]]:bg-ndor-surface-alt dark:has-[[data-state=checked]]:bg-zinc-800
                    ${r === member.role ? 'opacity-40' : ''}`}>
                  <RadioGroupItem value={r} id={`emp-role-${r}`} disabled={r === member.role} />
                  {r}
                </Label>
              ))}
            </RadioGroup>
          </div>
          <p className="rounded bg-amber-500/10 p-2 text-xs text-amber-200 dark:bg-amber-950/30 dark:text-amber-200">
            Founder accounts cannot be demoted. Last-admin protection enforced by backend.
          </p>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={onClose}
              data-testid="emp-role-cancel">Cancel</Button>
            <Button type="submit" disabled={busy || newRole === member.role}
              data-testid="emp-role-submit">
              {busy ? 'Updating…' : 'Modify role'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
